import { render, staticRenderFns } from "./AlternativeApproverSelection.vue?vue&type=template&id=0ac5e176&"
import script from "./AlternativeApproverSelection.vue?vue&type=script&lang=js&"
export * from "./AlternativeApproverSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports